import { HARPA_API } from 'src/app/app.api';
import { UsuarioService } from './../layout/perfil-usuario/usuario.service';
import { map, tap } from 'rxjs/operators';
import { Usuario } from './usuario.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jsonpFactory } from '@angular/http/src/http_module';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { PermissoesService } from '../permissoes.service';

@Injectable({providedIn: 'root'})
export class LoginService {

    private messageTabSubscription: Subscription
    private messageTabSubject = new Subject<any>();
    private channelTabToken = new BroadcastChannel('tokenTabComunication');

    public currentUserSubject: BehaviorSubject<Usuario>;
    public currentUser: Usuario;

    usuario: Usuario = new Usuario();
    usuarioAutenticado: boolean = false;

    constructor(private http: HttpClient,
                private router: Router,
                private permissoes: PermissoesService) { this.doActiveRealTime() }

    //#region === FUNCOES DE CONSULTA DO USUARIO ===

    onGetUserCode(): string
    {
        const userCode = localStorage.getItem('UserCode').replace('"', '').replace('"', '')

        return userCode;
    }

    onGetUserName(): string
    {
        return (localStorage.getItem('UserName')) ? atob(localStorage.getItem('UserName')) : '';
    }

    onGetUserLastName(): string
    {
        return (localStorage.getItem('userLastName')) ? atob(localStorage.getItem('userLastName')) : '';
    }

    onGetUserImage(): string
    {
        return (localStorage.getItem('userImage')) ? atob(localStorage.getItem('userImage')) : 'assets/images/user-default.png';
    }

    onGetUserCompanyId(): string
    {
        return (localStorage.getItem('companyId')) ? atob(localStorage.getItem('companyId')) : undefined;
    }

    onGetUserCompanyName(): string
    {
        return (localStorage.getItem('companyName')) ? atob(localStorage.getItem('companyName')) : '';
    }

    onGetUserDepartment(): string
    {
        return (localStorage.getItem('departamentoId')) ? localStorage.getItem('departamentoId') : '';
    }

    onGetCompanyImage() {
        return this.http.get(`${HARPA_API}/empresa/me`)
    }

    public get currentUsuarioValue(): Usuario {
        return this.currentUserSubject.getValue();
    }

    //#endregion

    //#region === FUNCOES DE LOGIN ===

    Login(email: string, password: string): Observable<Usuario>{
        return this.http.post<Usuario>(`${HARPA_API}/usuarios/login`, {email: email, senha: password}).pipe(tap((user: any) => {
            this.doSetLoginUser(user.usuario)
        }))
    }

    isLoggedIn(): boolean {
        if (sessionStorage.getItem('currentUser')) {
            return true;
        }
        return false;
    }

    doSetLoginUser(userSession: any) {
        this.doPostMessage(userSession)
        this.storeTokens(userSession);
    }

    handleLogin(path?: string) {
        this.router.navigate(['/login', btoa(path)]);
    }

    //#endregion

    //#region === FUNCOES DE CADASTRO ===

    signup(usuario: string, senha: string): Observable<Usuario> {
        return this.http.post<Usuario>(`${HARPA_API}/usuarios/login`,
            {
                email: usuario,
                senha: senha
            }
        ).pipe(tap(retorno => {
            this.currentUser = retorno;
        }));
    }

    //#endregion

    //#region === FUNCOES LOGOUT ===

    logout() {
      this.permissoes.setAdministrador(false);
      this.permissoes.setAcessoModulo([]);
      sessionStorage.removeItem('currentUser');
      this.router.navigate(['/login']);
    }

    //#endregion

    //#region === FUNCOES TOKEN ===

    refreshToken() {
        return this.http.post(`${HARPA_API}/usuarios/renovarToken`, {token: sessionStorage.getItem("TokenRenovacao")})
    }

    private storeTokens(userSession: any) {
        this.doSetTokensSessionStorage(userSession)

        localStorage.setItem('UserCode', userSession.id);
        localStorage.setItem('UserName',  btoa(userSession.nome));
        localStorage.setItem('userLastName', (userSession.sobrenome) ? btoa(userSession.sobrenome) : '');
        localStorage.setItem('userImage', (userSession.linkImage) ? btoa(userSession.linkImage) : '');

        localStorage.setItem('companyId', (userSession.empresa.id) ? userSession.empresa.id : '');
        localStorage.setItem('companyName', (userSession.empresa.nome) ? btoa(userSession.empresa.nome) : '');

        localStorage.setItem('departamentoId', (userSession.departamento.id) ? userSession.departamento.id : '')
    }

    private onMessageTokenStorage(userSession: any) {
        const tokenAccessToken = sessionStorage.getItem('currentUser') || undefined
        if (tokenAccessToken) this.doSetTokensSessionStorage(userSession)
    }

    private doSetTokensSessionStorage(userSession: any) {
        let accessToken: string
        let refreshToken: string
        let serviceLayerToken: string

        accessToken = userSession && userSession.tokenHarpa && userSession.tokenHarpa.accessToken
        refreshToken = userSession && userSession.tokenHarpa && userSession.tokenHarpa.refreshToken
        serviceLayerToken = userSession && userSession.tokenServiceLayer

        sessionStorage.setItem('currentUser', accessToken)
        sessionStorage.setItem('TokenRenovacao', refreshToken);
        sessionStorage.setItem('TokenServiceLayer', serviceLayerToken);
    }

    //#endregion

    //#region === FUNCOES DE ATUALIZACAO TAB NAVEGADORES ===

    private doActiveRealTime() {
        this.doActiveChannel()

        this.messageTabSubscription = this.getMessagesTabs().subscribe(res => {
            this.onMessageTokenStorage(res)
        })
    }

    private doActiveChannel() {
        this.channelTabToken.onmessage = (event) => {
            this.messageTabSubject.next(event.data);
        };
    }

    private doPostMessage(value: any) {
        this.channelTabToken.postMessage(value);
    }

    private getMessagesTabs(): Observable<any> {
        return this.messageTabSubject.asObservable();
    }

    //#endregion

}
